export const ratios = {
  square: {
    name: 'square',
    label: '1:1',
    value: 1
  },
  broadcast: {
    name: 'broadcast',
    label: '4:3',
    value: 1.33
  },
  cinema: {
    name: 'cinema',
    label: '16:9',
    value: 1.77
  }
};